export const actions = {
  setAuthToken({ commit }, authToken) {
    commit("setAuthToken", authToken);
  },
  setDeviceId({ commit }, deviceId) {
    commit("setDeviceId", deviceId);
  },
  setRegistered({ commit }, registered) {
    commit("setRegistered", registered);
  },
  setErrorMessage({ commit }, errorMessage) {
    commit("setErrorMessage", errorMessage);
  },
  setOwnProfile({ commit }, payload) {
    commit("setOwnProfile", payload);
  },
  setHybridPage({ commit }, payload) {
    commit("setHybridPage", payload);
  },
  setSettings({ commit }, payload) {
    commit("setSettings", payload);
  },
  setActiveLoginComponent({ commit }, activeLoginComponent) {
    commit("setActiveLoginComponent", activeLoginComponent);
  },
};
